import React, { useState } from 'react';
import { GOLD, BLACK } from '../constants/theme';
import { IMGS } from '../constants/images';
import SecLabel from './ui/SecLabel';
import GoldBtn from './ui/GoldBtn';

const cuisines = [
  { name:'South Indian',  img:IMGS.cuisine[0] },
  { name:'North Indian',  img:IMGS.cuisine[1] },
  { name:'Continental',   img:IMGS.cuisine[2] },
  { name:'Asian Fusion',  img:IMGS.cuisine[3] },
  { name:'Mediterranean', img:IMGS.cuisine[4] },
  { name:'Desserts',      img:IMGS.cuisine[5] },
  { name:'Beverages',     img:IMGS.cuisine[6] },
];

const CuisineMenu: React.FC = () => {
  const [hovIdx, setHovIdx] = useState<number | null>(null);
  return (
    <section id="menu" style={{ background:BLACK, padding:'90px 8vw' }}>
      <SecLabel text="EXPLORE OUR MENU"/>
      <h2 style={{ fontFamily:'Cormorant Garamond', fontSize:'clamp(28px,3.6vw,48px)', fontWeight:300, color:'#fff', textAlign:'center', marginTop:6 }}>
        Our Signature <em style={{ color:GOLD }}>Cuisines</em>
      </h2>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(230px,1fr))', gap:3, marginTop:44 }}>
        {cuisines.map((c,i) => (
          <div key={c.name} style={{ position:'relative', overflow:'hidden', cursor:'pointer', aspectRatio:'4/3' }}
            onMouseEnter={() => setHovIdx(i)} onMouseLeave={() => setHovIdx(null)}>
            <img src={c.img} alt={c.name} style={{ width:'100%', height:'100%', objectFit:'cover', transform:hovIdx===i?'scale(1.1)':'scale(1)', transition:'transform 0.6s ease' }}/>
            <div style={{ position:'absolute', inset:0, background:hovIdx===i?'rgba(0,0,0,0.62)':'rgba(0,0,0,0.3)', transition:'all 0.4s' }}/>
            <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'flex-end', padding:22 }}>
              <div style={{ width:26, height:1, background:GOLD, marginBottom:9, opacity:hovIdx===i?1:0, transition:'opacity 0.3s' }}/>
              <p style={{ fontFamily:'Cormorant Garamond', fontSize:19, fontWeight:400, color:'#fff', letterSpacing:2, textTransform:'uppercase' }}>{c.name}</p>
              <span style={{ marginTop:9, padding:'6px 16px', border:`1px solid ${GOLD}`, color:GOLD, fontFamily:'Montserrat', fontSize:9, letterSpacing:2, display:'inline-block', opacity:hovIdx===i?1:0, transform:hovIdx===i?'translateY(0)':'translateY(8px)', transition:'all 0.4s' }}>Explore</span>
            </div>
          </div>
        ))}
      </div>
      <div style={{ textAlign:'center', marginTop:44 }}><GoldBtn href="#">View All Menu</GoldBtn></div>
    </section>
  );
};

export default CuisineMenu;